import React from 'react';
import {useTranslation} from 'react-i18next';
import {SpinnerButton} from '../../SpinnerButton';
import {ACTION_OTHER_ACCOUNT, ACTION_RETRY, ACTION_SEND_LINK, errorViewOf} from './mercadoAds';

const ACTION_LABEL_KEYS = {
    [ACTION_RETRY]: 'connections.mercado_ads.action.retry',
    [ACTION_OTHER_ACCOUNT]: 'connections.mercado_ads.action.other_account',
    [ACTION_SEND_LINK]: 'mercado_ads_link.choose.send_link',
};

/**
 * Un error de la conexión con Mercado Ads, donde ocurrió: título, qué pasó y qué hacer, con sus
 * acciones (`copy.md` §4). `onAction(action)` decide qué hace cada una; `busyAction` deja ocupada la
 * que está yendo a Mercado Libre. Sin `onAction` se dibuja sin botones. `allowedActions` recorta las que
 * no tienen sentido donde se dibuja (en el Portal, el cliente no se manda un link a sí mismo), y
 * `textKeys` cambia el texto de un código por el de esa pantalla (`{código: clave}`).
 */
export function MercadoAdsErrorView({code, nickname = null, onAction = null, busyAction = null, allowedActions = null,
                                        textKeys = null}) {
    const {t} = useTranslation();
    const base = errorViewOf(code, nickname);
    const view = textKeys && textKeys[base.code] ? {...base, textKey: textKeys[base.code]} : base;
    const raw = {nickname, interpolation: {escapeValue: false}};
    const actions = !onAction ? []
        : view.actions.filter((action) => !allowedActions || allowedActions.includes(action));

    return (
        <div className="ma-error" role="alert" data-testid="mercado-ads-error" data-code={view.code}>
            {view.titleKey && <span className="ma-error__title">{t(view.titleKey, raw)}</span>}
            <span className="ma-error__text">{t(view.textKey, raw)}</span>
            {actions.length > 0 && (
                <span className="ma-error__actions">
                    {actions.map((action, index) => (
                        <button key={action} type="button" className={index === 0 ? 'btn -alt' : 'btn -alt -negative'}
                                disabled={busyAction !== null} aria-busy={busyAction === action || undefined}
                                data-testid={`mercado-ads-action-${action}`} onClick={() => onAction(action)}>
                            {busyAction === action && <SpinnerButton/>}
                            {t(ACTION_LABEL_KEYS[action])}
                        </button>
                    ))}
                </span>
            )}
        </div>
    );
}

export default MercadoAdsErrorView;
